<div class="page container">
  <h5>En cliquant sur ce bouton, vous vous attribuerez une séance automatiquement. <br>
    Merci de la renvoyer dans l'heure.</h5>
  <h5>Cette séance ne sera pas décomptée de votre compteur de séance jour s'il est prévu que vous receviez des textes aujourd'hui.</h5>
  @if (initLoad) {
<div class="col-3">
    <app-loader></app-loader>
  </div>
}
  @if ((!onAir?.canGenerate || !onAir) && !initLoad) {
<div class="row mt-5">
    <p>Séance OnAir indisponible pour le moment : </p>
    <p>{{onAir?.message}}</p>
  </div>
}
  @if (onAir?.canGenerate) {
<form class="row mt-5" (submit)="setOnAirSeance()">
    <div class="col-4">
      <select class="form-select" [formControl]="langueControl">
        @if (onAir?.langues.length > 1) {
<option value="">Choisir une langue</option>
}
        @for (langue of onAir?.langues; track langue) {
<option [value]="langue.codeLangue">
          {{ langue.libelle }}
        </option>
}
      </select>
    </div>
    <div class="col-1"></div>
    @if (!isLoading) {
<div class="col-3">
      <button class="btn btn-primary" [disabled]="langueControl.value === ''" type="submit">
        <i class="fa-solid fa-rotate me-2"></i>
        Générer la séance
      </button>
    </div>
}
    @if (isLoading) {
<div class="col-3">
      <app-loader></app-loader>
    </div>
}
  </form>
}
</div>
